/**
 * Meta pagination Super Admin Clients — lit nested `pagination` puis champs flat.
 * Ne jamais retomber sur data.length comme total global (page size, ex. 50).
 */

export const SA_PAGE_SIZE = 50;

export function normalizeUsersListData(response) {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response.data)) return response.data;
  return [];
}

/**
 * @param {object|array|null} usersDataResponse
 * @param {number} [pageSize=SA_PAGE_SIZE]
 * @returns {{ total: number, totalPages: number }}
 */
export function parseUsersListTotal(usersDataResponse, pageSize = SA_PAGE_SIZE) {
  const pag = usersDataResponse?.pagination || {};
  const size = Math.max(1, Number(pageSize) || SA_PAGE_SIZE);

  const total =
    typeof pag.total === 'number'
      ? pag.total
      : typeof usersDataResponse?.total === 'number'
        ? usersDataResponse.total
        : normalizeUsersListData(usersDataResponse).length;

  const totalPages =
    typeof pag.totalPages === 'number'
      ? pag.totalPages
      : typeof usersDataResponse?.pages === 'number'
        ? usersDataResponse.pages
        : Math.max(1, Math.ceil(total / size));

  return { total, totalPages };
}
